import RulerCreator from './RulerCreator';
import RulerDataGrid from './RulerDataGrid';
import Page from '../../components/Page';
import {
    Tabs,
    Tab,
} from '@mui/material';
import React from 'react';

import "./RulerPage.css";
import TabPanel from '../../components/TabPanel';

function RulerPage(){
    /// Ruler Page

    const [value, setValue] = React.useState(0);
    const handleTabChange = (event, newValue) => {
        setValue(newValue);
    };

    return(
        <Page title="Rulers">
            <Tabs value={value} onChange={handleTabChange} style={{ borderBottom: '2px solid darkGray', paddingBottom: '10px' }}>
                <Tab label="Ruler Table" />
                <Tab label="Ruler Generator" />
            </Tabs>
            <TabPanel className="rulerTab" value={value} index={0} style={{textAlign:'left'}}>
                <RulerDataGrid/>
            </TabPanel>
            <TabPanel className="rulerTab" value={value} index={1} style={{textAlign:'left'}}>
                <RulerCreator/>
            </TabPanel>
        </Page>
    )
};

export default RulerPage;